import ContentPage from "../../content/ContentPage";
import createMemoizer from "../../core/dashboard/createMemoizer";
import {
  Configuration,
  EditableResourceFields,
  Page,
} from "../../resources/modelTypes";
import { RootState } from "../../resources/reduxTypes";
import { selectCollection } from "../../resources/selectors";
import React, { useMemo } from "react";
import { connect } from "react-redux";

export type WebsiteCustomPageProps = {
  configuration: Configuration;
  id: string;
  pageData: Page;
  title: string;
};

type WebsiteCustomPagePropsWithRedux = {
  sections: EditableResourceFields[];
} & WebsiteCustomPageProps;

const WebsiteCustomPage = ({
  configuration,
  id,
  pageData,
  sections,
  title,
}: WebsiteCustomPagePropsWithRedux) => {
  const sortedSections = useMemo(
    () =>
      sections.sort(
        (sectionA, sectionB) => sectionA.position - sectionB.position,
      ),
    [sections],
  );

  return (
    <ContentPage
      configuration={configuration}
      data={sortedSections}
      id={id}
      pageData={pageData}
      title={title}
    />
  );
};

const memoizeSections = createMemoizer();

const mapStateToProps = (state: RootState, props: WebsiteCustomPageProps) => {
  const sections: EditableResourceFields[] = memoizeSections(
    selectCollection(state.resources.sections, {
      page: props.pageData.id,
    }).items.map((section) => ({
      // Map from content to description, so the rich text renders
      ...section.data,
      description: section.data.content,
    })),
  );

  return {
    sections,
  };
};

export default connect(mapStateToProps)(
  WebsiteCustomPage,
) as unknown as React.FC<WebsiteCustomPageProps>;
